import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 19.75v-10h4.001a2.25 2.25 0 0 0 2.25-2.251L12.248 3.5h5.002a.75.75 0 0 1 .75.75v15.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75m1.06-11.5 3.689-3.691.002 2.94a.75.75 0 0 1-.75.752zM4.5 9.622c0-.596.237-1.169.658-1.59l5.368-5.372c.422-.422.995-.659 1.592-.659h5.132a2.25 2.25 0 0 1 2.25 2.25v15.5A2.25 2.25 0 0 1 17.25 22H6.75a2.25 2.25 0 0 1-2.25-2.25zM15 13.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5zm-3 3a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }